import Reflection from 'actions/reflection';

export default Reflection.createReducer();
